import React, { useState, useEffect, useRef } from "react";
import "../styles/Home.css";


const Home = () => {
  const images = [
    "/images/Room.jpg",
    "/images/Room1.jpg",
    "/images/Room3.jpg",
    "/images/Restaurant.jpg",
    "/images/Restaurant1.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(1); // Start from 1 to skip the first clone
  const [isTransitioning, setIsTransitioning] = useState(true);
  const sliderRef = useRef(null);

  const totalSlides = images.length;
  const extendedImages = [images[totalSlides - 1], ...images, images[0]]; // Clone first and last image

  
  const nextSlide = () => {
    if (currentIndex >= totalSlides) {
      setIsTransitioning(false);
      setCurrentIndex(0);
      setTimeout(() => {
        setCurrentIndex(1);
        setIsTransitioning(true);
      }, 50);
    } else {
      setCurrentIndex((prev) => prev + 1);
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 2000);

    return () => clearInterval(interval);
   // eslint-disable-next-line 
  }, [currentIndex]);

  const getTranslateZ = () => {
    const baseWidth = 1024; // Reference width for larger screens
    const baseTranslateZ = 400; // Reference translateZ for larger screens
  
    return (window.innerWidth / baseWidth) * baseTranslateZ;
  };

  return (
    <div className="home-container" id="home">
        {/* Hotel Intro */}
        <div className="home-intro">
          <h2>Welcome to our hotel</h2>
          <h1>HOTEL SHYAM PALACE</h1>
          <p>
          Nestled in the serene beauty of Ghangaria, Uttarakhand. <b>Hemkund Sahib</b>, <b>Lokpal Lakshman Mandir</b>, and the <b>Valley of Flowers</b> are a short distance from our hotel. 
          We offer 7 well-furnished rooms <b> 3 double-bed</b> and <b>4 triple-bed</b>, all equipped with modern amenities, including hot water geysers. Enjoy delicious meals at our in-house restaurant and wake up to breathtaking Himalayan views for an unforgettable stay.
          </p>
        </div>

        {/* 3D Rotating Carousel */}
        <div className="slider-container">
          <div className="slider" ref={sliderRef} style={{ 
                                                            transform: `rotateY(${currentIndex * -(360 / totalSlides)}deg)`, 
                                                            transition: isTransitioning ? 'transform 0.8s ease-in-out' : 'none',
                                                            }}>
            {extendedImages.map((img, index) => {
               const angle = (360 / totalSlides) * index;
              return (
                <div key={index} className="slider-item" style={{transform: `rotateY(${angle}deg) translateZ(${getTranslateZ()}px)`}}>
                  <img src={img} alt={`Slide ${index + 1}`} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
  );
};

export default Home;
